import type { VendedorOption } from "../../../services/contratoAplicativo"

export type { VendedorOption }

export type ContratoAplicativoModel = {
    razaoSocial: string
    nomeFantasia: string
    cnpj: string
    nomeResponsavel: string
    emailResponsavel: string
    endereco: string
    valorAdesao: string
    valorMensalidade: string
    metaVendas: string
    formaPagamentoAdesao: string
    idVendedor: number | null
    termosEPolitica: string
    vendedores: VendedorOption[]
    podeEditar: boolean
}

export const ContratoAplicativoInicial: ContratoAplicativoModel = {
    razaoSocial: "",
    nomeFantasia: "",
    cnpj: "",
    nomeResponsavel: "",
    emailResponsavel: "",
    endereco: "",
    valorAdesao: "",
    valorMensalidade: "",
    metaVendas: "",
    formaPagamentoAdesao: "",
    idVendedor: null,
    termosEPolitica: "",
    vendedores: [],
    podeEditar: true,
}
